import { ANALYSES_LPU_DEFAULT_SORT } from 'src/components/pages/[town-translit]/diagnostika/analiz/_constants/analyses-lpu-sort'
import type { AnalysesPlaceItem } from 'src/components/pages/[town-translit]/diagnostika/analiz/api/apiAnalysesDistricts.types'
import type { AnalysesLpuCardsFilters } from 'src/components/pages/[town-translit]/diagnostika/analiz/api/apiAnalysesLpuCardsFilter.types'
import type { AnalysesPageContext } from 'src/components/pages/[town-translit]/diagnostika/analiz/_types'

function parseSort(value?: string) {
  if (value === 'recommend' || value === 'name') {
    return value
  }

  return undefined
}

function isTruthyQueryFlag(value?: string): boolean {
  return value === 'true' || value === '1'
}

function getPlaceFromContext(
  context: AnalysesPageContext,
): AnalysesPlaceItem | undefined {
  if (context.metro?.translit) {
    return {
      id: 0,
      name: context.metro.name,
      translit: context.metro.translit,
      isMetro: true,
    }
  }

  if (context.district?.translit) {
    return {
      id: 0,
      name: context.district.name,
      translit: context.district.translit,
      isMetro: false,
    }
  }

  return undefined
}

export function getAnalysesLpuCardsFiltersFromContext(
  context: AnalysesPageContext,
): AnalysesLpuCardsFilters | null {
  const query = context.request.GET || {}
  const sort = parseSort(query.sort)
  const onlineOrder = isTruthyQueryFlag(query.online_order)
  const withDiscount = isTruthyQueryFlag(query.order_discount)
  const place = getPlaceFromContext(context)

  const hasFilters = Boolean(
    place
    || onlineOrder
    || withDiscount
    || (sort && sort !== ANALYSES_LPU_DEFAULT_SORT),
  )

  if (!hasFilters) {
    return null
  }

  return {
    sort: sort || ANALYSES_LPU_DEFAULT_SORT,
    onlineOrder,
    withDiscount,
    place,
  }
}
